import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=bee02bcc&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
import style0 from "./Button.vue?vue&type=style&index=0&id=bee02bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee02bcc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MiscElementsSpinner: require('/home/runner/work/LTNG-1800-Frontend/LTNG-1800-Frontend/components/MiscElements/Spinner.vue').default})
